module.exports = __webpack_public_path__ + "static/media/snowflake.d2269ecc.png";